import { FC } from 'react';
import { Tr } from '@utils';
import { capitalCase } from 'change-case';
import { RoleWithAssignees } from '@services';
import { Box, Grid } from '@mui/material';
import { VoltaageModalDialog, IVoltaageModalDialogProps, StripedTableCell } from '@components/common';

export interface IRoleDetailDialogProps extends IVoltaageModalDialogProps {
	entity?: RoleWithAssignees;
}

export const RoleDetailDialog: FC<IRoleDetailDialogProps> = ({ entity, ...props }) => {
	return (
		<VoltaageModalDialog title={entity?.name || ''} dividers {...props}>
			<Box sx={{ paddingX: 10, paddinTop: 3, paddingBottom: 5 }}>
				<Grid container>
					<StripedTableCell title={<Tr.Portal path="roles.role-name" />}>{entity?.name || '-'}</StripedTableCell>
					<StripedTableCell title={<Tr.Portal path="roles.number-of-assignees" />}>
						{entity?.assignees.length || '0'}
					</StripedTableCell>

					{entity?.permissions.map((permission, i) => {
						return (
							<StripedTableCell
								key={`permission-${permission}-${i}`}
								title={<Tr.Portal path="roles.capability" />}
								greyBg={i % 4 < 2}
							>
								{capitalCase(permission.split('_').join(' ')) || '-'}
							</StripedTableCell>
						);
					})}
				</Grid>
			</Box>
		</VoltaageModalDialog>
	);
};
